import { isRecaptchaActive } from '@/lib/recaptcha';

/**
 * reCAPTCHA v3 renders no visible control — it scores the interaction in the background. What belongs on
 * screen is the disclosure Google requires whenever the badge is not shown.
 *
 * When the challenge is switched off or has no site key it cannot run at all, and saying so beats a
 * screen that silently looks protected when it is not.
 */
export function RecaptchaNotice(): React.JSX.Element {
  if (!isRecaptchaActive()) {
    return (
      <div className="border-gold-200 bg-gold-50 text-gold-800 mt-4 flex items-start gap-2.5 rounded-md border px-4 py-3 text-[13px] leading-relaxed">
        <span
          aria-hidden="true"
          className="border-gold-600 mt-0.5 h-3.5 w-3.5 flex-none rounded-full border-[1.6px]"
        />
        Bot protection is not enabled on this screen yet.
      </div>
    );
  }

  return (
    <p className="text-subtle mt-4 text-center text-xs leading-relaxed">
      This site is protected by reCAPTCHA and the Google{' '}
      <a
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noreferrer"
        className="underline"
      >
        Privacy Policy
      </a>{' '}
      and{' '}
      <a
        href="https://policies.google.com/terms"
        target="_blank"
        rel="noreferrer"
        className="underline"
      >
        Terms of Service
      </a>{' '}
      apply.
    </p>
  );
}
